import React from 'react';
import { Dropdown } from 'react-bootstrap';

export default function PlayerMenus({ actions, onSelect }) {
  return (
    <Dropdown drop="up" className="player-menus">
      <Dropdown.Toggle id="player-menus-toggle" variant="secondary" className={`player-menus__toggle ${actions.some((action) => action.className.includes('points-glow') || action.style?.backgroundColor === 'gold') ? 'points-glow' : ''}`} >
        Menus
      </Dropdown.Toggle>
      <Dropdown.Menu className="player-menus__list" aria-label="Player menus">
        {actions.map((action) => (
          <Dropdown.Item
            key={action.key}
            eventKey={action.key}
            aria-label={action.ariaLabel || action.title}
            className={(action.className.includes('points-glow') || action.style?.backgroundColor === 'gold') ? 'points-glow' : undefined}
            onClick={() => onSelect(action)}
          >
            {action.title}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
